import { ZENDESK_SUPPORT } from '@spotahome/customer-graphql-modules/dist/constants';

const NON_BOOKING_CATEGORY = 'non_booking';
const BOOKING_CATEGORY = 'booking';
const ACCOUNT_CATEGORY = 'account_issue';

export const TENANT_CATEGORY_IDS = [
  NON_BOOKING_CATEGORY,
  BOOKING_CATEGORY,
  ACCOUNT_CATEGORY
];

const SEARCH = 'search';
const TENANT_BUG = ZENDESK_SUPPORT.TENANT_REASONS.TENANT_BUG;
const TENANT_ACCOUNT_ACCESS =
  ZENDESK_SUPPORT.TENANT_REASONS.TENANT_ACCOUNT_ACCESS;
const TENANT_OTHER = ZENDESK_SUPPORT.TENANT_REASONS.TENANT_OTHER;
const DEACTIVATE_ACCOUNT = ZENDESK_SUPPORT.TENANT_REASONS.DEACTIVATE_ACCOUNT;

export const TENANT_SECTION_IDS = [
  SEARCH,
  TENANT_BUG,
  TENANT_ACCOUNT_ACCESS,
  TENANT_OTHER,
  DEACTIVATE_ACCOUNT
];

export const TENANT_CONFIG = {
  [BOOKING_CATEGORY]: {},
  [NON_BOOKING_CATEGORY]: {
    [SEARCH]: [
      ZENDESK_SUPPORT.TENANT_REASONS.LISTING_DOUBTS,
      ZENDESK_SUPPORT.TENANT_REASONS.HELP_FIND_PROPERTY,
      ZENDESK_SUPPORT.TENANT_REASONS.HOW_SPOTAHOME_WORKS,
      ZENDESK_SUPPORT.TENANT_REASONS.PAYMENT_SUPPORT
    ]
  },
  [ACCOUNT_CATEGORY]: {
    [TENANT_BUG]: [ZENDESK_SUPPORT.TENANT_REASONS.TENANT_BUG],
    [TENANT_OTHER]: [ZENDESK_SUPPORT.TENANT_REASONS.TENANT_OTHER],
    [DEACTIVATE_ACCOUNT]: [ZENDESK_SUPPORT.TENANT_REASONS.DEACTIVATE_ACCOUNT]
  }
};
